<template>
  <ion-page>
    <ion-content>
      <div style="color: #222">
        <div style="text-align: right; width: 100%">
          <ion-button @click="cancel()" fill="clear" color="light">
            Hủy chọn
            <ion-icon :icon="closeCircle" slot="end" color="dark"></ion-icon>
          </ion-button>
        </div>
        <ion-slides ref="slider" :pager="true" :options="slideOpts">
          <template v-for="(card, idx) in dataCards" :key="card.id">
            <ion-slide v-if="idx < linesToShow">
              <div class="card">
                <div class="title">
                  {{ card.id }}
                </div>
                <div class="selected">
                  <div class="selected-header">
                    <div style="color: #999; flex-grow: 1; text-align: left">
                      Số được chọn
                    </div>
                    <ion-button
                      :color="mpicks[card.id] > 0 ? 'warning' : 'dark'"
                      :fill="mpicks[card.id] > 0 ? 'solid' : 'outline'"
                      size="small"
                      @click="setMpick(card.id)"
                    >
                      Tự Chọn
                    </ion-button>
                  </div>

                  <div
                    style="
                      justify-content: center;
                      display: grid;
                      grid-template-columns: repeat(6, auto);
                      grid-gap: 1vw;
                    "
                  >
                    <span v-for="(val, idx) in numsToPick" :key="idx">
                      <span v-if="selected[card.id].length > idx">{{
                        selected[card.id][idx]
                          ? $utils.zpad2(selected[card.id][idx])
                          : "TC"
                      }}</span>
                    </span>
                    <span v-if="subgame == 'pwcover5'">
                      <span>&#x2217;</span>
                    </span>
                  </div>
                </div>
                <div
                  class="selection"
                  :class="mpicks[card.id] > 0 ? 'disabled' : ''"
                >
                  <span v-for="(val, idx) in parseInt(maxNum)" :key="idx">
                    <span
                      v-if="!selected[card.id].includes(val)"
                      @click="selectBall(card, val)"
                      >{{ $utils.zpad2(val) }}</span
                    >
                    <span
                      class="selected-ball"
                      v-else
                      @click="!deselectBall(card, val)"
                      >{{ $utils.zpad2(val) }}</span
                    >
                  </span>
                </div>
                <div class="footer">
                  <div class="foot-title">{{ card.id }}</div>
                  <div class="toolbox">
                    <ion-button
                      @click="wizpick(card)"
                      fill="clear"
                      size="small"
                      color="light"
                    >
                      Ngẫu nhiên <ion-icon :icon="dice" slot="end"></ion-icon>
                    </ion-button>
                    <ion-button
                      @click="clearPick(card)"
                      fill="clear"
                      size="small"
                      color="light"
                    >
                      Xóa <ion-icon :icon="trash" slot="end"></ion-icon>
                    </ion-button>
                  </div>
                </div>
              </div>
            </ion-slide>
          </template>
        </ion-slides>
        <div style="text-align: center">
          <ion-button @click="confirmCards()" fill="solid" color="success">
            Xác nhận
          </ion-button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style scoped>
ion-content {
  --background: transparent;
}
ion-slide {
  padding-bottom: 5vh;
  width: 70vw;
  flex-direction: column;
  font-size: 1em;
  /*font-weight: 200;*/
}

.card {
  width: 100%;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.selected-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 1rem;
}

.card .title {
  background: #ff992f;
  color: white;
  font-weight: 700;
  text-align: left;
  padding: 1vw;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  width: 100%;
}
.card .selection {
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(10, 1fr);
  padding: 0 5vw;
}
.card .selection > span {
  margin-top: 0.6vh;
  display: flex;
  justify-content: center;
}

.card .selection > span > span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7.5vw;
  height: 7.5vw;
  border: 1px solid #888;
  color: #666;
  border-radius: 100%;
  font-size: 1em;
}

.card .selection > span > span.selected-ball {
  color: white;
  background: #804d18;
  border: 1px solid #804d18;
}

.card .selection.disabled > span > span,
.card .selection.disabled > span > span.selected-ball {
  color: #aaa;
  background: #e4e4e4;
  border: 1px solid #e4e4e4;
}

.card .selected {
  margin-bottom: 1vh;
}

.card .selected div > span {
  width: 7vw;
  height: 7vw;
  border-bottom: 2px solid #999;
  margin: 0 1vw;
}
.card .footer .foot-title {
  text-align: right;
  margin: 0.5vh 1vw;
  color: #ff992f;
  font-weight: bold;
}

.card .footer .toolbox {
  background: #f60;
  color: white;
  font-weight: 700;
  text-align: right;
  padding: 1vw;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.card .footer .toolbox button {
  background: transparent;
  color: white;
  margin: 1vw 3vw;
}
</style>

<script>
import { defineComponent } from "vue";
import {
  IonSlides,
  IonSlide,
  IonIcon,
  IonPage,
  IonContent,
  IonButton,
  modalController,
} from "@ionic/vue";
import { dice, trash, closeCircle } from "ionicons/icons";
import { cloneDeep, random, clone } from "lodash";

export default defineComponent({
  name: "PowerPick",
  props: ["cards", "selectedIndex", "numsToPick", "linesToShow", "subgame", "selectedStages"],
  components: {
    IonSlides,
    IonSlide,
    IonButton,
    IonIcon,
    IonPage,
    IonContent,
  },
  data() {
    return {
      maxNum: 55,
      maxSelect: 6,
      selected: {
        A: [],
        B: [],
        C: [],
        D: [],
        E: [],
        F: [],
      },
      mpicks: {
        A: 0,
        B: 0,
        C: 0,
        D: 0,
        E: 0,
        F: 0,
      },
      dataCards: [],
      slideOpts: {
        initialSlide: 0,
        speed: 400,
        init: false,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 15,
      },
      cardMap: ["A","B","C","D","E","F"],
    };
  },
  methods: {
    getAllSelection() {
      let selection = [];
      for (let i = 0; i < this.linesToShow; i++) {
        selection = [...selection, ...this.selected[this.cardMap[i]]];
      }
      return selection;
    },
    async wizpick(card) {
      await this.$utils.showLoading();
      this.$utils.callAPI2('POST', '/api/wizpick/power', {
        "stage": this.selectedStages && this.selectedStages.length > 0 ? parseInt(this.selectedStages[0]) : 0,
        "selection": this.getAllSelection(),
        "pick": this.numsToPick,
      }).then(async (resp) => {
        console.log(resp);
        this.selected[card.id] = resp.data.numbers;
        this.mpicks[card.id] = 0;
        await this.$utils.hideLoading();
      }).catch(async () => {
        this.randomPick(card);
        await this.$utils.hideLoading();
      })
    },
    randomPick(card) {
      this.selected[card.id] = [];
      this.mpicks[card.id] = 0;
      let picks = [];
      while (picks.length < this.numsToPick) {
        const pick = random(1, this.maxNum, false);
        if (!picks.includes(pick)) picks.push(pick);
      }
      picks = picks.sort((n1, n2) => n1 - n2);
      this.selected[card.id] = picks;
    },
    clearPick(card) {
      this.selected[card.id] = [];
      this.mpicks[card.id] = 0;
    },
    setMpick(key) {
      this.selected[key] = Array(this.numsToPick).fill(0);
      this.mpicks[key] = this.numsToPick;
    },
    cancel() {
      modalController.dismiss({
        cancel: true,
      });
    },
    confirmCards() {
      for (const [key, value] of Object.entries(this.selected)) {
        if (
          value.length == this.numsToPick &&
          (value.length - value.filter(Number).length == 0 ||
            this.mpicks[key] > 0)
        ) {
          this.dataCards.forEach((item, index) => {
            if (item.id == key) {
              this.dataCards[index].nums = this.selected[item.id];
              this.dataCards[index].mpick = this.mpicks[item.id];
              this.dataCards[index].selected = true;
            }
          });
        } else if (value.length == 0) {
          this.dataCards.forEach((item, index) => {
            if (item.id == key) {
              this.dataCards[index].nums = [];
              this.dataCards[index].selected = false;
              this.dataCards[index].mpick = 0;
            }
          });
        } else {
          console.log("invalid card: ", key);
          this.$utils.toast("Số chọn chưa hợp lệ!");
          this.$refs.slider.$el.slideTo(key.charCodeAt(0) - 65);
          return false;
        }
      }
      modalController.dismiss({
        dataCards: this.dataCards,
      });
    },
    selectBall(card, val) {
      if (this.selected[card.id].length == this.numsToPick) return;
      this.selected[card.id].push(val);
      this.selected[card.id].sort((n1, n2) => n1 - n2);
    },
    deselectBall(card, val) {
      this.selected[card.id].splice(this.selected[card.id].indexOf(val), 1);
      this.selected[card.id].sort((n1, n2) => n1 - n2);
    },
  },
  mounted() {
    this.dataCards = cloneDeep(this.cards);
    this.dataCards.forEach((card) => {
      this.selected[card.id] = clone(card.nums);
      this.mpicks[card.id] = card.mpick;
    });
    this.$refs.slider.$el.getSwiper().then((instance) => {
      setTimeout(() => {
        if (this.selectedIndex > 0)
          instance.on("init", () => {
            instance.slideTo(this.selectedIndex, 500);
          });

        instance.init();
      }, 10);
    });
  },
  setup() {
    return {
      dice,
      trash,
      closeCircle,
    };
  },
});
</script>
